module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Text/H1-3d23eb82f509dd3801f9c928ab40a355e3f3a4f6684bbcb5e43ed64eca486058.svg";